import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { ENABLE_EIN_UPDATE } from '#client/constants/experimentsFlags';

function EIN() {
  const enableEINUpdate = useExperimentFlag(ENABLE_EIN_UPDATE, false);

  if (!enableEINUpdate) {
    return null;
  }

  return (
    <Stack orientation="horizontal" alignItems="center" gap={0.5}>
      <Text size="xs" weight="medium">
        EIN:
      </Text>
      <Text size="xs">
        Pending
      </Text>
    </Stack>
  );
}

export { EIN };
